module.exports = __webpack_public_path__ + "media/react/fonts/fa-solid-900-ba0b120fe013ca88a4da96fbbb2cda09.ttf";